export default "__VITE_ASSET__7922251e__"